import { DeviceStatus } from '@app/modules/streamer-box/components/Device';
import { Device } from '@mi-front/core';
import { BtnLink, MrtTable, theme } from '@mi-front/ui';
import { Build as ManageIcon } from '@mui/icons-material';
import { UseQueryResult } from '@tanstack/react-query';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import StreamerBoxIcon from '../../components/StreamerBoxIcon';

interface Props {
  readonly query: UseQueryResult<readonly Device[], Error>;
}

export default function DevicesList(props: Props) {
  const { $t } = useIntl();
  const { query } = props;
  const devices = query.data ?? [];

  return (
    <MrtTable
      data={query.isLoading ? [] : [...devices]}
      state={{
        isLoading: query.isLoading,
        showSkeletons: query.isLoading,
      }}
      columns={[
        {
          Header: $t({
            id: 'streamerBox.props.device',
            defaultMessage: 'Dispositivo',
          }),
          w: 25,
          accessor: (device: Device) => (
            <>
              <StreamerBoxIcon
                style={{
                  marginRight: '0.5rem',
                  color: device.isOnline ? theme.green : theme.pink,
                }}
              />
              <Link className="font-weight-medium" to={`/streamer-box/devices/${device.id}`}>
                {device.name}
              </Link>
            </>
          ),
        },
        {
          Header: $t({
            id: 'streamerBox.props.status',
            defaultMessage: 'Estado',
          }),
          w: 25,
          align: 'center',
          accessor: (device: Device) => <DeviceStatus device={device} />,
        },
        {
          Header: 'ID',
          w: 20,
          align: 'center',
          accessor: (device: Device) => <span className="text-gray-600">#{device.id}</span>,
        },
        {
          Header: $t({
            id: 'common.text.actions',
            defaultMessage: 'Acciones',
          }),
          accessor: (device: Device) => {
            return (
              <BtnLink
                size="xs"
                type="outline-primary"
                to={`/streamer-box/devices/${device.id}`}
                icon={<ManageIcon />}
              >
                <FormattedMessage
                  id="streamerBox.listScreen.manageBtn"
                  defaultMessage="Administrar dispositivo"
                />
              </BtnLink>
            );
          },
          align: 'center',
        },
      ]}
    />
  );
}
